<template>
  <b-sidebar
    bg-variant="white"
    right
    backdrop
    width="40vw"
    :shadow="true"
    :visible="show"
    @change="onChangeSidebar"
  >
    <ActivitySidebarHeader
      :activity="activity"
      v-if="!config.usingForm"
    />
    <div class="container" v-if="!config.usingForm">
      <div class="row">
        <div class="col-12">
          <CheckPermission permission="ED068">
            <b-form-checkbox
              class="custom-control-warning float-right mb-2"
              name="check-button"
              switch
              v-model="editMode"
            >
              <span class="switch-icon-left">
                <feather-icon icon="ActivityIcon" />
              </span>
              <span class="switch-icon-right">
                <feather-icon icon="CodeIcon" />
              </span>
            </b-form-checkbox>
          </CheckPermission>
        </div>
      </div>
    </div>
    <ActivityForm
      v-if="editMode || usingForm"
      :selected-activity="activity"
      :column="config.column"
      :kanban-id="kanbanId"
      :reference-id="referenceId"
      :reference-type="referenceType"
      :reference-number="referenceNumber"
      :edit-mode="editMode"
      :on-updated="() => this.editMode = false"
    />
    <ActivityDetail
      v-else-if="activityId"
      :activity="activity"
    />
  </b-sidebar>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import ActivityForm from '@/febos/global/kanban/components/ActivityForm';
import ActivityDetail from '@/febos/global/kanban/components/ActivityDetail';
import ActivitySidebarHeader from '@/febos/global/kanban/components/ActivitySidebarHeader';
import { getActivity } from '@/febos/global/kanban/store/getters';
import { fetchActivity } from '@/febos/global/kanban/store/actions';

export default {
  data() {
    return {
      editMode: this.config.usingForm
    };
  },
  computed: {
    ...mapGetters('kanban', {
      getActivity: getActivity.name
    }),
    activity() {
      return this.getActivity(this.kanbanId, this.activityId);
    },
    usingForm() {
      return this.config.usingForm;
    }
  },
  methods: {
    ...mapActions('kanban', {
      fetchActivity: fetchActivity.name
    }),
    onChangeSidebar(value) {
      if (!value) {
        this.editMode = false;
        this.$emit('close');
      }
    }
  },
  watch: {
    activityId(activityId) {
      if (activityId) {
        this.fetchActivity({ kanbanId: this.kanbanId, activityId });
      }
    }
  },
  components: {
    CheckPermission,
    ActivitySidebarHeader,
    ActivityDetail,
    ActivityForm
  },
  props: {
    activityId: [Number, String],
    config: {
      usingForm: { type: Boolean, default: false },
      column: { type: Object, default: () => {} }
    },
    show: { type: Boolean, default: false },
    kanbanId: { type: String, required: true },
    referenceId: String,
    referenceType: String,
    referenceNumber: String
  }
};

</script>
<style lang="scss">

.markdown {
  min-height: 120px;
}

</style>
